module.exports = __webpack_public_path__ + "static/media/sf_1400_gray.e7aa9a1b12698902f1762e0e60a99220.png";